import Image from 'next/image'
import type { ReactNode } from 'react'
import { OpenChatBlock } from '@/components/global/open-chat-block'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import mailBoxImg from '@/public/img/mailbox.svg'

interface SuportModalProps {
  children: ReactNode
  defaultSupportEmailUnity: string
}

export default function SuportModal({
  children,
  defaultSupportEmailUnity,
}: SuportModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent className="w-full max-w-150 py-4">
        {/* <DialogClose className="ml-auto max-w-max">
          <X className="size-5" />
        </DialogClose> */}

        <DialogHeader className="flex items-center space-y-6">
          <p className="text-gray-400 text-sm">
            Informamos que a emissão de Notas Fiscais é realizada exclusivamente
            para pagamentos efetuados no ano vigente, em conformidade com a
            política interna da nossa empresa. Não emitimos Notas Fiscais
            retroativas.
          </p>
          <div className="flex flex-wrap items-center gap-x-16 gap-y-6 lg:flex-nowrap">
            <div className="space-y-2">
              <DialogTitle className="text-2xl text-[#333333]">
                Fale com nossa Equipe de Suporte
              </DialogTitle>
              <DialogDescription className="font-medium text-gray-500 text-sm">
                Estamos a disposição para lhe ajudar no que precisar.
              </DialogDescription>
            </div>
            <Image alt="" height={179.77} src={mailBoxImg} width={210} />
          </div>
        </DialogHeader>

        <div className="-mt-8 flex flex-wrap items-center gap-x-4 gap-y-4 lg:flex-nowrap">
          <OpenChatBlock />

          <a
            className="flex h-[7.0175rem] w-full flex-1 flex-col items-center justify-center rounded-md bg-[#3496fa] text-center font-semibold text-white text-xl"
            href={`mailto:${defaultSupportEmailUnity}`}
            rel="noreferrer"
            target="_blank"
          >
            Atendimento via E-mail
            <small className="block font-normal text-sm">
              {defaultSupportEmailUnity}
            </small>
          </a>

          {/* <HomeLink
            className="flex h-[7.0175rem] w-full flex-1 flex-col items-center justify-center rounded-md bg-[#3496fa] font-semibold text-white text-xl"
            href={'/suporte/whatsapp'}
            rel="noreferrer"
            target="_blank"
          >
            <div className="flex items-center justify-center gap-x-4 px-7 text-center">
              <Image alt="" className="size-8" src={whatsAppLogoIcon} />
              Atendimento via Whatsapp
            </div>
          </HomeLink> */}
        </div>
      </DialogContent>
    </Dialog>
  )
}
